'use strict';

require('core/rxForm');
